import { render, staticRenderFns } from "./Flags.vue?vue&type=template&id=248d7780&scoped=true"
import script from "./Flags.vue?vue&type=script&lang=js"
export * from "./Flags.vue?vue&type=script&lang=js"
import style1 from "./Flags.vue?vue&type=style&index=1&id=248d7780&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248d7780",
  null
  
)

export default component.exports